import { jsx, jsxs } from "react/jsx-runtime";
import { Collapse } from "@perxis-auto/ui-kit/lib/components/Collapse";
import { Divider } from "@perxis-auto/ui-kit/lib/components/Divider";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Icon } from "@perxis-auto/ui-kit/lib/components/Icon";
import { Typography } from "@perxis-auto/ui-kit/lib/components/Typography";
import clsx from "clsx";
import styles from "./Item.module.scss.js";
function Item({ groups, showIcon = false }) {
  const isHidden = !groups.length;
  const isShowCollapse = groups.length > 2;
  const renderRow = (itemsMatrix) => {
    return /* @__PURE__ */ jsx(Row, { gutter: [0, "vertical-sky"], children: itemsMatrix.map((items) => {
      const item = items.find((item2) => item2);
      if (!item) {
        return null;
      }
      return /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-purple"], children: [
        /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Typography.Paragraph, { level: "main", color: "dark-light", className: styles.item__label, children: item.label }) }),
        /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx("div", { className: styles.item__row, children: items.map((item2, itemIndex, self) => {
          const itemKey = `${(item2 == null ? void 0 : item2.id) || 0}-${itemIndex}`;
          const isBooleanValues = self.every((item3) => typeof (item3 == null ? void 0 : item3.value) === "boolean" || !item3);
          if (showIcon && isBooleanValues) {
            const icon = (item2 == null ? void 0 : item2.value) ? "check" : "minus";
            return /* @__PURE__ */ jsx(
              Icon,
              {
                name: icon,
                size: 24,
                sticker: "comparison-equipment-item-icon",
                className: clsx(styles.item__icon, styles[`item__icon--${icon}`])
              },
              itemKey
            );
          }
          const value = (item2 == null ? void 0 : item2.formattedValue) ?? (item2 == null ? void 0 : item2.value) ?? "—";
          return /* @__PURE__ */ jsx(Typography.Text, { level: "main", color: "darkest", className: styles.item__value, children: value }, itemKey);
        }) }) })
      ] }) }, item.id);
    }) });
  };
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ jsx(Row, { gutter: [0, "vertical-yellow"], className: styles.item, children: /* @__PURE__ */ jsxs(Col, { span: 24, children: [
    /* @__PURE__ */ jsx(Divider, { width: "thick", color: "dark", curved: true }),
    isShowCollapse ? /* @__PURE__ */ jsx(
      Collapse,
      {
        items: groups.map(({ id, title, items }) => ({
          key: id,
          label: title,
          children: renderRow(items)
        })),
        defaultActiveKey: groups == null ? void 0 : groups[0].id
      }
    ) : /* @__PURE__ */ jsx("div", { className: styles.item__singleTable, children: renderRow(groups[0].items) })
  ] }) });
}
export {
  Item
};
